import React from 'react'
import { PolicyRecord } from '@trustero/trustero-api-web/lib/model/policy_pb'
import { GridColumn, GridRow } from '../../../../../components/Reusable/Grid'
import { Title } from '../../../../Reusable/Text/Title'
import { CheckBoxInput } from '../../../../Reusable/Inputs/CheckBox/CheckBoxInput'
import { DepartmentChip } from '../../../../../pages/Controls/DepartmentChip'

export type SelectPoliciesRowItemProps = {
  policy: PolicyRecord
  onSelect: (policyIds: string[]) => void
  selectedPolicyIds: string[]
  customDepartmentElement?: JSX.Element
}

export const SelectPoliciesRowItem = ({
  policy,
  onSelect,
  selectedPolicyIds,
  customDepartmentElement,
}: SelectPoliciesRowItemProps): JSX.Element => {
  const modelId = policy.getModelId()
  const selectedPolicies = new Set(selectedPolicyIds)
  const name = policy.getName()
  const departmentId = policy.getDepartmentId()

  const onChangeHandler = (): void => {
    if (selectedPolicies.has(modelId)) {
      selectedPolicies.delete(modelId)
    } else {
      selectedPolicies.add(modelId)
    }
    onSelect(Array.from(selectedPolicies))
  }

  return (
    <GridRow id={`select-controls-item-${modelId}`}>
      <GridColumn>
        <CheckBoxInput
          id={modelId}
          checked={selectedPolicies.has(modelId)}
          onClick={(e) => e.stopPropagation()}
          onChange={onChangeHandler}
        />
      </GridColumn>
      <GridColumn>
        {customDepartmentElement || (
          <DepartmentChip departmentId={departmentId} />
        )}
      </GridColumn>
      <GridColumn
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
      >
        <div>
          <Title name={name} />
        </div>
      </GridColumn>
    </GridRow>
  )
}
